/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Status_PendingInputs */

const vi_pl_status_pending = /** @type {(inputs: Pl_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chờ duyệt`)
};

/**

* @param {Pl_Status_PendingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_status_pending = /** @type {((inputs?: Pl_Status_PendingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Status_PendingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_status_pending(inputs)
});